import { memo } from 'react';
import { VisualShieldIcon } from '../../icons';
import Grid, { IGridProps } from '../Grid';
import Typography from '../Typography';
import Box from '../Box';
import { useSecurityScore } from '../../hooks/useSecurityScore';
import { mergeSX } from '../../services/helpers';

interface IBuildSXParams {
  backgroundColor: string;
}

const buildSX = ({ backgroundColor }: IBuildSXParams) => ({
  borderRadius: '8px',
  maxWidth: '62px',
  backgroundColor,
});

export interface ISecurityScoreIconProps extends IGridProps {
  percentage: number;
}

const SecurityScoreIcon = (props: ISecurityScoreIconProps) => {
  const { percentage, sx, ...rest } = props;

  const { color, backgroundColor } = useSecurityScore({
    score: percentage,
  });

  return (
    <Grid
      container
      p={0.5}
      justifyContent="center"
      alignItems="center"
      sx={mergeSX(buildSX({ backgroundColor }), sx)}
      {...rest}
    >
      <Grid item>
        <Box display="flex" mr={0.5}>
          <VisualShieldIcon width={16} height={15} color={color} />
        </Box>
      </Grid>
      <Grid item>
        <Typography variant="caption" color={color}>
          {percentage}
          %
        </Typography>
      </Grid>
    </Grid>
  );
};

export default memo(SecurityScoreIcon);
